import script from "./UpdateIncomeSourcesError.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateIncomeSourcesError.vue?vue&type=script&setup=true&lang=ts"

import "./UpdateIncomeSourcesError.vue?vue&type=style&index=0&id=1fe8ffa0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe8ffa0"]])

export default __exports__